import React from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen } from 'lucide-react';
const TOMOS = ['Introducción al Reiki', 'Autosanación y práctica personal', 'Chakras y energía vital', 'Símbolos del Reiki', 'Reiki emocional y espiritual', 'Integración y camino del practicante'];
export function IncludedSection() {
  return <section className="bg-white py-24 md:py-32 px-4 relative" data-id="element-147">
      <div className="container mx-auto max-w-4xl text-center" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-149">
          <div className="flex justify-center mb-6" data-id="element-150">
            <div className="bg-green-50 p-3 rounded-full" data-id="element-151">
              <BookOpen className="w-8 h-8 text-green-600" data-id="element-152" />
            </div>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6 leading-tight" data-id="element-153">
            📘 ¿Qué incluye el MegaPack?
          </h2>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl font-medium text-gray-600 max-w-2xl mx-auto" data-id="element-154">
            Una biblioteca completa de conocimiento sagrado, <br data-id="element-155" />
            <span className="text-green-700 font-bold" data-id="element-156">
              ✔ 6 Tomos completos de Reiki
            </span>{' '}
            organizados para tu aprendizaje.
          </motion.p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-157">
          {TOMOS.map((tomo, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.06
        }} whileHover={{
          y: -2,
          backgroundColor: '#F0FDF4'
        }} className="group flex items-center gap-4 bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md hover:border-green-200 transition-all duration-300" data-id="element-158">
              <div className="flex-shrink-0 w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center group-hover:bg-green-100 transition-colors" data-id="element-159">
                <span className="font-serif font-bold text-green-700" data-id="element-160">
                  {idx + 1}
                </span>
              </div>

              <div className="flex-grow text-left" data-id="element-161">
                <span className="text-xs font-bold text-green-600 uppercase tracking-wider mb-0.5 block" data-id="element-162">
                  Tomo {idx + 1}
                </span>
                <span className="text-gray-800 font-medium text-lg leading-tight block" data-id="element-163">
                  {tomo}
                </span>
              </div>

              <div className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-164">
                <Check className="w-5 h-5 text-green-500" data-id="element-165" />
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="inline-block bg-gray-50 px-8 py-4 rounded-full border border-gray-200" data-id="element-166">
          <p className="text-lg text-gray-600 italic font-serif" data-id="element-167">
            "Todo explicado de forma clara, simple y aplicable."
          </p>
        </motion.div>
      </div>
    </section>;
}